import angular from 'angular';
import config from 'app/config';

import { AppService } from './app.service';
import { PageService } from './page.service';
import { userService } from './user.service';
import { DayjsService } from './dayjs.service';

export default angular
  .module(`${config.appName}.commonServices`, [])
  .service('AppService', AppService)
  .service('PageService', PageService)
  .service('userService', userService)
  .service('DayjsService', DayjsService)
  .name;
